import type { TagResponse } from '@/api/client';

/**
 * Get the category ID from a link's tags (e.g., "category:nsfw" -> "nsfw")
 */
export function getCategoryFromTags(tags?: TagResponse[]): string | undefined {
	const categoryTag = tags?.find((t) => t.name.startsWith('category:'));
	return categoryTag?.name.replace('category:', '');
}

/**
 * Get the category tag object from a link's tags
 */
export function getCategoryTag(tags?: TagResponse[]): TagResponse | undefined {
	return tags?.find((t) => t.name.startsWith('category:'));
}

/**
 * Get the category color from tags, with fallback
 */
export function getCategoryColor(tags?: TagResponse[], defaultColor = '#94a3b8'): string {
	const categoryTag = getCategoryTag(tags);
	return categoryTag?.color ?? defaultColor;
}

/**
 * Format category ID for display (snake_case -> kebab-case)
 */
export function formatCategoryId(categoryId: string): string {
	return categoryId.replace(/_/g, '-');
}
